import React from "react";

import { useTranslation } from "react-i18next";

import { PasswordValidateContainer, ValidationText, ValidationTitle, StyledImage } from "./styles";

const CHECK_ICON = require("Assets/img/check-icon.svg");
const MINUS_ICON = require("Assets/img/minus.svg");

interface PasswordValidateProps {
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
  isLongEnough: boolean;
}

const PasswordValidate: React.FC<PasswordValidateProps> = ({
  hasUppercase,
  hasLowercase,
  hasNumber,
  hasSpecialChar,
  isLongEnough,
}) => {
  const { t: translate } = useTranslation();

  return (
    <PasswordValidateContainer>
      <ValidationTitle>{translate("passwordMustHave") || "Your password must have:"}</ValidationTitle>
      <ValidationText style={{ color: hasUppercase && hasLowercase ? "#1D2939" : "#98A2B3" }}>
        <StyledImage src={hasUppercase && hasLowercase ? CHECK_ICON : MINUS_ICON} />
        {translate("UpperAndLowercaseLetters") || "Upper and lowercase letters"}
      </ValidationText>
      <ValidationText style={{ color: hasSpecialChar ? "#1D2939" : "#98A2B3" }}>
        <StyledImage src={hasSpecialChar ? CHECK_ICON : MINUS_ICON} />
        {translate("aSpecialCharacter") || "A special character (#$&@)"}
      </ValidationText>
      <ValidationText style={{ color: hasNumber ? "#1D2939" : "#98A2B3" }}>
        <StyledImage src={hasNumber ? CHECK_ICON : MINUS_ICON} />
        {translate("atLeastOneNumber") || "At least one number"}
      </ValidationText>
      <ValidationText style={{ color: isLongEnough ? "#1D2939" : "#98A2B3" }}>
        <StyledImage src={isLongEnough ? CHECK_ICON : MINUS_ICON} />
        {translate("minLength") || "12 or more characters"}
      </ValidationText>
    </PasswordValidateContainer>
  );
};

export default PasswordValidate;
